import React, {useLayoutEffect, useMemo } from "react";
import styles from "../../pages/DifferencePage/DifferencePage.module.scss";
import {IconButton, SxProps, Theme} from "@mui/material";
import {getDifferenceName} from "../../selectors/other";
import {IDetailedDocument, IDiscrepancyStatus,} from "../../api/monitoringApi";
import {ListItemContainer, StarIconBackground, StarIconFront} from "./styles";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

export interface IDifferenceListStateProps {
    detailedDiff: string | undefined;
    detailedDocLeft: IDetailedDocument | undefined;
    discrepancyFilters: string[];
}

export interface IDifferenceListDispatchProps {
    setDetailedDiff: (diff: string | undefined) => void;
    setDifferenceStatus: (index: number, status: IDiscrepancyStatus) => void;
    setAllDifferencePinned: (value: boolean) => void;
}

export type DifferenceListProps = IDifferenceListStateProps & IDifferenceListDispatchProps;

enum Differences {
    'StartBalanceDifference',
    'MissingRow',
    'DebitAndCreditDifference',
    'MissingContractor',
    'DatesDifference',
    'TurnoverDifference',
    'FinalBalanceDifference'
}

const iconSxProp: SxProps<Theme>= {
    color: 'red'
};

export function DifferenceList (props: DifferenceListProps) {
    const {detailedDiff, setDetailedDiff, setDifferenceStatus, detailedDocLeft, setAllDifferencePinned, discrepancyFilters} = props;

    const onSetDetailedDiff = (diff: string | undefined) => {
        if (diff) {
            setDetailedDiff(diff);
        }
    }

    useLayoutEffect(() => {
        setTimeout(() => {
            if (detailedDiff) {
                setTimeout(() => {
                    const discrepancyGroup = document.getElementsByClassName( `${styles.commentsContainerItem} ${styles.selectedItem}`)?.item(0)
                    discrepancyGroup?.scrollIntoView({inline: 'center', block: 'center'})
                }, 50)
            }
        }, 25)
    }, [detailedDiff]);

    const isAllImportant = useMemo(() => {
        if(!detailedDocLeft) return false;
        try{
            const array = detailedDocLeft.docflowDocumentData.extendData.discrepancyData;
            return !array.filter(el => discrepancyFilters.includes(el.type)).some((el) => el.status.length === 1 && !el.status[0].pinned);

        }
        catch {
            return false;
        }

    }, [detailedDocLeft, discrepancyFilters]);

    const onSetAllIsImportant = () => {
        setAllDifferencePinned(!isAllImportant);
    }

    return  <div className={`${styles.subContainer} ${styles.withoutBackground}`}>
        <div className={styles.starIconsContainer}>
            <IconButton
                onClick={onSetAllIsImportant}
                title={!isAllImportant ? 'Отметить все как важные' : 'Отметить все как не важные'}
                size={'small'}
            >
                <div
                    className={styles.doubleIcon}
                >
                    <StarIconBackground isDetailed={isAllImportant}/>
                    <StarIconFront isDetailed={isAllImportant}/>
                </div>
            </IconButton>
        </div>
        {detailedDocLeft && detailedDocLeft.docflowDocumentData.extendData.discrepancyData.sort((diff1, diff2) => {
            return Differences[diff1.type] > Differences[diff2.type] ? 1 : Differences[diff1.type] < Differences[diff2.type] ? -1 : 0
        }).map((diff) => {
            const detailsData = diff.details.reduce((previousValue, {rowId}) => ([...previousValue, rowId]), []);
            return {...diff, detailsData};
        }).map((diff, topIndex, list) => {
            const diffID = diff.details ? `${diff.apiIndex}` : "";
            const isPinned = diff.status.length === 1 && diff.status[0].pinned;
            const nextElement = list[topIndex + 1];
            const prevElement = list[topIndex - 1];

            const onPin = (event) => {
                event.stopPropagation();
                setDifferenceStatus(topIndex, {
                    accept: false,
                    pinned: !isPinned
                })
            }
            const isVisible = discrepancyFilters.includes(diff.type);

            return isVisible ?  <ListItemContainer
                isSelected={detailedDiff === diffID}
                isNextSameRow={nextElement?.detailsData.some((rowId) => diff.detailsData.includes(rowId))}
                isPrevSameRow={prevElement?.detailsData.some((rowId) => diff.detailsData.includes(rowId))}
                key={`${getDifferenceName(diff.type)}${topIndex}`}
                elevation={0}
                className={`${styles.commentsContainerItem} ${(detailedDiff === diffID) && styles.selectedItem}  ${['StartBalanceDifference', 'NumbersDifference', 'CauseDatesDifference',].includes(diff.type) ? styles.commentsContainerItemHigh : styles.commentsContainerItemLow}`}
                onClick={() => {
                    onSetDetailedDiff(diffID);
                }}
            >
                <div className={styles.commentsContainerItemWrapper}>
                    <div
                        className={`${styles.commentsContainerItemWrapperItem}`}>
                        <div className={styles.text}>{getDifferenceName(diff.type)}</div>
                    </div>
                </div>
                <div className={styles.commentsContainerItemWrapper}>
                    <div className={styles.commentsContainerItemWrapperItemClose}>
                        <IconButton
                            title={'Отметить как важное'}
                            size={"small"}
                            onClick={onPin}>
                            {isPinned ?
                                <StarIcon
                                    sx={iconSxProp}
                                    fontSize="inherit"
                                /> :
                                <StarBorderIcon
                                    fontSize="inherit"
                                />}
                        </IconButton>
                    </div>
                </div>
            </ListItemContainer> : <></>
        })}
    </div>
}
